module.exports = __webpack_public_path__ + "static/media/4C.89ac8bfd.svg";